import ContactUsForm from '../components/forms/ContactUsForm';

import './ContactUs.scss';

function ContactUsPage() {
	return (
		<>
			<div>
				<ContactUsForm />
			</div>
		</>
	);
}

export default ContactUsPage;
